import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";
import { STATUS_MAP, PRIORITY_MAP, CATEGORY_MAP } from "@/lib/constants";

export function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || { label: status, badge: "" };
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${s.badge}`}
      data-testid={`status-badge-${status}`}
    >
      {s.label}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const p = PRIORITY_MAP[priority] || { label: priority, badge: "" };
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${p.badge}`}
      data-testid={`priority-badge-${priority}`}
    >
      {p.label}
    </span>
  );
}

export function CategoryBadge({ category }) {
  const c = CATEGORY_MAP[category] || { label: category };
  return (
    <Badge variant="outline" className="rounded-full border-forest-200 bg-forest-50 text-forest-700 font-medium">
      {c.label}
    </Badge>
  );
}

export function AITriageBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-bone-100 border border-gold/40 px-3 py-1 text-xs font-semibold text-charcoal-700">
      <Sparkles className="h-3.5 w-3.5 text-gold" strokeWidth={1.5} />
      AI Triage
    </span>
  );
}
